import SideBar from "@/components/Sidebar";
import { Box } from "@chakra-ui/react";
import { Outlet, ScrollRestoration, useNavigate } from "react-router";
import { useUserSession } from "./hooks/useUserSession";
import { useEffect } from "react";
import Footer from "./ui/Footer";
import { PaperCoinsDisclaimer } from "./hooks/usePaperCoinsDisclaimer";
import CompleteAuthBanner from "./components/CompleteAuthBanner";
import PromoBanner from "./components/PromoBanner";
import { useTranslation } from "react-i18next";
import { updateDoc } from "firebase/firestore";
import { authIa } from "@/lib/firebase";

const Layout = () => {
  const { user, isReady } = useUserSession();

  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (isReady) {
      if (!user) {
        navigate("/login", {
          state: {
            from: window.location.pathname,
          },
        });
        return;
      }
      const logFromExternProvider = authIa?.currentUser?.providerData?.some(
        (provider) =>
          provider.providerId === "google.com" ||
          provider.providerId === "apple.com"
      );
      if (
        new Date(user?.createdAt?.seconds * 1000).toISOString() >
          // TODO - Start date checking, need to move it in .env
          new Date("2025-07-08").toISOString() &&
        !user.emailVerified &&
        !logFromExternProvider
      ) {
        navigate("/email-verification", {
          state: {
            from: window.location.pathname + window.location.search,
          },
        });
        return;
      }
    }
  }, [user, isReady, navigate]);

  useEffect(() => {
    if (user && user.language !== i18n.language) {
      updateDoc(user.ref, {
        language: i18n.language,
      });
    }
  }, [user, i18n.language]);

  return (
    <PaperCoinsDisclaimer>
      <Box
        width={"100%"}
        minH={"100vh"}
        background={"#E6F2F0"}
        display={"flex"}
        flexDir={"row"}
        alignItems={"stretch"}
        position={"relative"}
      >
        <SideBar />
        <Box
          display={"flex"}
          alignItems={"stretch"}
          justifyContent={"flex-start"}
          width={"100%"}
          minH={"100vh"}
          overflow={"hidden"}
          flexDirection={"column"}
        >
          <CompleteAuthBanner />
          <PromoBanner />
          <Outlet />
        </Box>
      </Box>
      <Footer />
      <ScrollRestoration />
    </PaperCoinsDisclaimer>
  );
};

export default Layout;
